import { Routes } from '@angular/router';
import { NotificationsSendComponent } from './notifications-send.component';

export const notificationsSendRoutes: Routes = [
  {
    path: 'notifications-send',
    component: NotificationsSendComponent,
  },
];
